import template from "./settings-taxes-row.html";

const SettingsTaxesRowComponent = {
  bindings: {
    tax: "<",
    editMode: "<",
    onCreate: "&",
    onCancel: "&",
  },
  template: template,
  controller: class SettingsTaxesRowController {
    /* @ngInject */
    constructor($rootScope, $state, OrganizationService, Tax) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.OrganizationService = OrganizationService;
      this.Tax = Tax;
    }

    $onInit() {
      this.editMode = false;
      this.loading = false;
    }

    $onChanges(changesObj) {
      this.originalTax = new this.Tax(changesObj.tax.currentValue);
      this.editableTax = new this.Tax(changesObj.tax.currentValue);
    }

    async save() {
      if (!this.form.$valid) return;

      this.loading = true;
      if (this.editableTax.isNew()) {
        await this.OrganizationService.createTax(
          this.editableTax.name,
          this.editableTax.percentage
        );
        this.loading = false;
        this.$state.reload();
        this.$rootScope.$applyAsync();
        this.onCreate();
      } else {
        await this.OrganizationService.editTax(
          this.editableTax._id,
          this.editableTax.name,
          this.editableTax.percentage,
          this.editableTax.default
        );
        this.loading = false;
        this.$state.reload();
        this.$rootScope.$applyAsync();
      }
    }

    async deleteTax() {
      if (!this.form.$valid) return;

      this.loading = true;
      await this.OrganizationService.deleteTax(this.editableTax._id);
      this.loading = false;
      this.$state.reload();
      this.$rootScope.$applyAsync();
    }

    valueHasBeenModified() {
      return !angular.equals(this.originalTax, this.editableTax);
    }
  },
};

export default SettingsTaxesRowComponent;
